import { globalStyle } from "@thkStore/theme/post/globalStyle";
import { colors } from "@thkStore/theme/pre/colors";

export const preTheme = {
    colors,
    globalStyle,    
};